import React, { Component } from "react";

export default class EmploymentFormContainer extends Component {
  render() {
    return (
      <div
        className="white-bg "
        style={{
          paddingTop: 20,
          border: "1px solid lightgrey",
          display: "grid",
          marginTop: 10,
          marginBottom: 200,
          paddingBottom: 20,
          boxShadow: "5px 5px 5px lightgrey",
        }}
      >
        {this.props.children}
      </div>
    );
  }
}
